export const LOAD_CONFIG_REQUEST = 'load_config_request';
export const LOAD_CONFIG_SUCCESS = 'load_config_success';
export const LOAD_CONFIG_FAILURE = 'load_config_failure';
export const DELETE_CONFIG_REQUEST = 'delete_config_request';
export const DELETE_CONFIG_SUCCESS = 'delete_config_success';
export const DELETE_CONFIG_FAILURE = 'delete_config_failure';
export const SAVE_CONFIG_REQUEST = 'save_config_request';
export const SAVE_CONFIG_SUCCESS = 'save_config_success';
export const SAVE_CONFIG_FAILURE = 'save_config_failure';
export const DELETE_CONFIG_MODAL_OPEN = 'delete_config_modal_open';
export const DELETE_CONFIG_MODAL_CLOSE = 'delete_config_modal_close';
export const DISMISS_SAVE_CONFIG_ERROR = 'dismiss_save_config_error';
export const SET_EXECUTIONS_COUNT = 'set_executions_count';
export const INITIALIZE = 'initialize';
export const ADD_METRIC = 'add_metric';
export const RENAME_METRIC = 'rename_metric';
export const EDIT_METRIC_BEGIN = 'edit_metric_begin';
export const EDIT_METRIC_CONFIRM = 'edit_metric_modal_confirm';
export const EDIT_METRIC_CANCEL = 'edit_metric_modal_cancel';
export const UPDATE_METRIC_DIRECTION = 'update_metric_direction';
export const UPDATE_METRIC_NAN_STRATEGY = 'update_metric_nan_strategy';
export const UPDATE_METRIC_OUTLIER_STRATEGY = 'update_metric_outlier_strategy';
export const UPDATE_METRIC_CRITICALITY = 'update_metric_criticality';
export const UPDATE_METRIC_DATA_REQUIRED = 'update_metric_data_required';
export const UPDATE_EFFECT_SIZE = 'update_effect_size';
export const UPDATE_METRIC_GROUP = 'update_metric_group';
export const UPDATE_METRIC_SCOPE_NAME = 'update_metric_scope_name';
export const REMOVE_METRIC = 'remove_metric';
export const SELECT_CONFIG = 'select_config';
export const CLEAR_SELECTED_CONFIG = 'clear_selected_config';
export const UPDATE_CONFIG_SUMMARIES = 'update_config_summaries';
export const ADD_GROUP = 'add_group';
export const SELECT_GROUP = 'select_group';
export const UPDATE_CONFIG_NAME = 'update_config_name';
export const UPDATE_CONFIG_DESCRIPTION = 'update_config_description';
export const CONFIG_JSON_MODAL_OPEN = 'config_json_modal_open';
export const CONFIG_JSON_MODAL_CLOSE = 'config_json_modal_close';
export const SET_CONFIG_JSON = 'set_config_json';
export const UPDATE_PROMETHEUS_METRIC_TYPE = 'update_prometheus_metric_type';
export const UPDATE_PROMETHEUS_METRIC_QUERY_FIELD = 'update_prometheus_metric_query_field';
export const UPDATE_PROMETHEUS_LABEL_BINDINGS = 'update_prometheus_label_bindings';
export const UPDATE_PROMETHEUS_GROUP_BY_FIELDS = 'update_prometheus_group_by_fields';
export const UPDATE_STACKDRIVER_METRIC_TYPE = 'update_stackdriver_metric_type';
export const UPDATE_STACKDRIVER_METRIC_QUERY_FIELD = 'update_stackdriver_metric_query_field';
export const UPDATE_STACKDRIVER_GROUP_BY_FIELDS = 'update_stackdriver_group_by_fields';
export const UPDATE_JUDGES = 'update_judges';
export const SELECT_JUDGE_NAME = 'select_judge_name';
export const UPDATE_GROUP_WEIGHT = 'update_group_weight';
export const SET_CONFIG_JSON_MODAL_TAB_STATE = 'set_config_json_modal_tab_state';
export const UPDATE_ATLAS_QUERY = 'update_atlas_query';
export const UPDATE_DATADOG_METRIC_TYPE = 'update_datadog_metric_type';
export const UPDATE_DATADOG_METRIC_NAME = 'update_datadog_metric_name';
export const UPDATE_NEWRELIC_SELECT = 'update_newrelic_select';
export const COPY_SELECTED_CONFIG = 'copy_selected_config';
export const CREATE_NEW_CONFIG = 'create_new_config';
export const EDIT_GROUP_BEGIN = 'edit_group_name_begin';
export const EDIT_GROUP_CONFIRM = 'edit_group_name_confirm';
export const EDIT_GROUP_UPDATE = 'edit_group_name_update';
export const CHANGE_METRIC_GROUP = 'change_metric_group';
export const CHANGE_METRIC_GROUP_SELECT = 'change_metric_group_select';
export const CHANGE_METRIC_GROUP_CONFIRM = 'change_metric_group_confirm';
export const LOAD_RUN_REQUEST = 'load_run_request';
export const LOAD_RUN_SUCCESS = 'load_run_success';
export const LOAD_RUN_FAILURE = 'load_run_failure';
export const TOGGLE_METRIC_CLASSIFICATION_FILTER = 'toggle_metric_classification_filter';
export const SELECT_REPORT_METRIC_GROUP = 'select_result_metric_group';
export const SELECT_REPORT_METRIC = 'select_result_metric';
export const LOAD_METRIC_SET_PAIR_REQUEST = 'load_metric_set_pair_request';
export const LOAD_METRIC_SET_PAIR_SUCCESS = 'load_metric_set_pair_success';
export const LOAD_METRIC_SET_PAIR_FAILURE = 'load_metric_set_pair_failure';
export const ADD_TEMPLATE = 'add_template';
export const EDIT_TEMPLATE_BEGIN = 'edit_template_begin';
export const EDIT_TEMPLATE_CANCEL = 'edit_template_cancel';
export const EDIT_TEMPLATE_CONFIRM = 'edit_template_confirm';
export const EDIT_TEMPLATE_NAME = 'edit_template_name';
export const EDIT_TEMPLATE_VALUE = 'edit_template_value';
export const DELETE_TEMPLATE = 'delete_template';
export const SELECT_TEMPLATE = 'select_template';
export const EDIT_INLINE_TEMPLATE = 'edit_inline_template';
export const LOAD_METRICS_SERVICE_METADATA_REQUEST = 'load_metrics_service_metadata_request';
export const LOAD_METRICS_SERVICE_METADATA_SUCCESS = 'load_metrics_service_metadata_success';
export const LOAD_METRICS_SERVICE_METADATA_FAILURE = 'load_metrics_service_metadata_failure';
export const UPDATE_PROMETHEUS_METRIC_DESCRIPTOR_FILTER = 'update_prometheus_metric_descriptor_filter';
export const UPDATE_GRAPHITE_METRIC_DESCRIPTOR_FILTER = 'update_graphite_metric_descriptor_filter';
export const UPDATE_STACKDRIVER_METRIC_DESCRIPTOR_FILTER = 'update_stackdriver_metric_descriptor_filter';
export const UPDATE_DATADOG_METRIC_DESCRIPTOR_FILTER = 'update_datadog_metric_descriptor_filter';
export const LOAD_EXECUTIONS_REQUEST = 'load_executions_request';
export const LOAD_EXECUTIONS_SUCCESS = 'load_executions_success';
export const LOAD_EXECUTIONS_FAILURE = 'load_executions_failure';
export const SELECT_GRAPH_TYPE = 'select_graph_type';
export const LOAD_KAYENTA_ACCOUNTS_REQUEST = 'load_kayenta_accounts_request';
export const LOAD_KAYENTA_ACCOUNTS_SUCCESS = 'load_kayenta_accounts_success';
export const LOAD_KAYENTA_ACCOUNTS_FAILURE = 'load_kayenta_accounts_failure';
export const SELECT_METRIC_STORE = 'select_metric_store';
export const UPDATE_SIGNAL_FX_METRIC_NAME = 'update_signalfx_metric_name';
export const UPDATE_SIGNAL_FX_AGGREGATION_METHOD = 'update_signalfx_aggregation_method';
export const UPDATE_SIGNAL_FX_QUERY_PAIRS = 'update_signalfx_query_pairs';
export const UPDATE_GRAPHITE_METRIC_NAME = 'update_graphite_metric_name';
